<div class="outer-wrapper">
  <button
    *ngIf="toolbarPageLayoutService.showOptionsButton$ | async"
    class="btn btn-outline-primary toggle-button me-0 apt-btn"
    data-test-selector="show-options-button"
    [ngClass]="
      (toolbarPageLayoutService.showOptions$ | async) ? 'active' : 'inactive'
    "
    data-dd-action-name="Toolbar: Toggle Options button"
    [disabled]="!!(toolbarPageLayoutService.disableOptions$ | async)"
    (click)="toolbarPageLayoutService.toggleShowOptions()"
  >
    <i class="fa fa-lg fa-sliders-h fw-300"></i>
  </button>
  <button
    *ngIf="toolbarPageLayoutService.showFiltersButton$ | async"
    class="btn btn-outline-primary toggle-button me-0 apt-btn"
    data-test-selector="show-filters-button"
    data-dd-action-name="Toolbar: Toggle Filters button"
    [ngClass]="
      (toolbarPageLayoutService.showFilters$ | async) ? 'active' : 'inactive'
    "
    (click)="toolbarPageLayoutService.toggleShowFilters()"
  >
    <i class="fa fa-lg fa-filter fw-500"></i>
  </button>
  <button
    *ngIf="toolbarPageLayoutService.showChartsButton$ | async"
    class="btn btn-outline-primary toggle-button me-0 apt-btn"
    data-test-selector="show-charts-button"
    data-dd-action-name="Toolbar: Toggle Charts button"
    [ngClass]="
      (toolbarPageLayoutService.showCharts$ | async) ? 'active' : 'inactive'
    "
    (click)="toolbarPageLayoutService.toggleShowCharts()"
  >
    <i class="fa fa-lg fa-chart-bar fw-500"></i>
  </button>
  <div class="wrapper">
    <ng-content></ng-content>
  </div>
</div>
